import PropTypes from 'prop-types';
import React from 'react'
import { Link } from 'react-router-dom'
import classNames from 'classnames'
import { findWhere } from 'underscore'

import Reply from './ReplyPart'

export default class extends React.Component {
    static propTypes = {
		ID: PropTypes.number.isRequired,
		title: PropTypes.string.isRequired,
		date: PropTypes.string.isRequired,
		description: PropTypes.string,
		duplicate: PropTypes.string,
		replies: PropTypes.array.isRequired
	};

    render() {
		return (
			<div>
				<h1 className="entry-title">
		    		{this.props.title}
	    		</h1>
	    		<p className="lead mbot20">{this.props.description}</p>
            	{this.props.replies.map(reply => {
            		return <Reply qID={this.props.ID} dispatch={this.props.dispatch} {...reply} />
            	})}
            	<Reply qID={this.props.ID} parent={0} dispatch={this.props.dispatch} />
        	</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Statement/components/StatementPart.jsx